<div class="sidebar" [class.collapsed]="collapsed">
  <!-- Logo Section -->
  <div class="logo-section">
    <div class="logo-container">
        <!-- Hamburger / collapse toggle -->
        <button class="sidebar-hamburger" type="button" (click)="onToggleSidebar()" aria-label="Toggle sidebar">
          <i class="fa-solid fa-bars"></i>
        </button>
      <div class="logo-icon">
        <img
          src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/dropaddy/dropaddy-v8-color-transparent.png"
          alt="DropAddy"
          class="balloon-logo"
          (error)="logoLoadError = true"
          *ngIf="!logoLoadError">
        <div class="image-not-found" *ngIf="logoLoadError">Not found</div>
      </div>
    </div>
  </div>

  <!-- Navigation Menu -->
  <nav class="nav-menu">
    <ul class="nav-list">
      <li class="nav-item"
          *ngFor="let item of menuItems"
          [class.active]="isActive(item.route)"
          (click)="setTitle(item.label)">
        <a class="nav-link"
           [routerLink]="item.route"
           routerLinkActive="active">
          <i class="nav-icon" [class]="item.icon"></i>
          <span class="nav-label" *ngIf="!collapsed">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </nav>
</div>
